var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UtilTag',{staticClass:"flex items-center space-x-2 border auction-tag"},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.faGavel}}),_vm._v(" "),_c('span',[_vm._v("Auction")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }